import { sendTrackingEvent } from '../services/service.tracking';

const send = (action: string) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: `accept-or-counteroffer::${action}`,
    eventNonInteractive: false,
  });
};

const close = (modal: string, finished: boolean) => send(`button::${modal}::close${finished ? '::finished' : ''}`);

export default {
  openModal: {
    acceptOffer: () => send('cta::modal::accept-offer'),
    counteroffer: () => send('cta::modal::make-a-counteroffer'),
  },
  acceptOffer: {
    yes: () => send('cta::accept-offer::yes'),
    close: (finished: boolean) => close('accept-offer', finished),
  },
  counteroffer: {
    close: (finished: boolean) => close('counteroffer', finished),
    make: () => send('cta::counteroffer::make'),
    edit: () => send('cta::counteroffer::edit'),
    submit: () => send('cta::counteroffer::submit'),
  },
};
